import { cva, type VariantProps } from 'class-variance-authority'

import Container from '@/components/structure/Container'

import { cn } from '@/lib/utils'

type ErrorProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof variants> & {
    title: string
    message: string
    theme?: 'dark' | 'light'
  }

const variants = cva('p-40', {
  variants: {
    theme: {
      dark: 'bg-dark-950 text-white',
      light: 'bg-white text-dark-950',
    },
  },
})

export default function Errors({ title, message, theme }: ErrorProps) {
  return (
    <div className={cn(variants({ theme }))}>
      <Container className="flex items-center justify-center text-center">
        <div>
          <h1>{title}</h1>
          <p>{message}</p>
        </div>
      </Container>
    </div>
  )
}
